import { useAalKpisQuery } from "../aalV2";

export type PromosAALKPIsFilters = {
  start_date: string;
  end_date: string;
  promo_status?: string;
};

export type PromosAALKPIsResponse = {
  free_picks_given?: number;
  free_picks_given_pct_change?: number;
  free_picks_removed?: number;
  free_picks_removed_pct_change?: number;
  free_picks_amount?: string | number;
  free_picks_amount_pct_change?: number;
  free_picks_amount_realized?: string | number;
  free_picks_amount_realized_pct_change?: number;
  profit_boosts_given?: number;
  profit_boosts_given_pct_change?: number;
  profit_boosts_removed?: number;
  profit_boosts_removed_pct_change?: number;
  profit_boosts_amount?: string | number;
  profit_boosts_amount_pct_change?: number;
  profit_boosts_amount_realized?: string | number;
  profit_boosts_amount_realized_pct_change?: number;
  free_spins_given?: number;
  free_spins_given_pct_change?: number;
  free_spins_removed?: number;
  free_spins_removed_pct_change?: number;
  free_spins_amount?: string | number;
  free_spins_amount_pct_change?: number;
  free_spins_amount_realized?: string | number;
  free_spins_amount_realized_pct_change?: number;
  comparison_start_date?: string;
  comparison_end_date?: string;
} | null;

export const useGetAALPromosKPIs = (filters: PromosAALKPIsFilters) => {
  const { start_date, end_date, promo_status } = filters;

  return useAalKpisQuery<PromosAALKPIsResponse>("promos", {
    start_date,
    end_date,
    filters: { promo_status },
  });
};
